var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwCFunctIconsCalendarOutlineBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 104 99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Calendar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.25,21.41v-9h-4.5v9H36.25v-9h-4.5v9H20.5v58.5a4.5,4.5,0,0,0,4.5,4.5H79a4.5,4.5,0,0,0,4.5-4.5V21.41ZM79,79.91H25V39.41H79Zm0-45H25v-9H79ZM72.25,73.16h-4.5v-4.5h4.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwCFunctIconsCalendarOutlineBlackRgb);
export default __webpack_public_path__ + "static/media/PwC_Funct_Icons_Calendar_Outline_Black_RGB.1f8d20da016bc84ff77611d3ddb1aa96.svg";
export { ForwardRef as ReactComponent };